import { Record } from 'immutable'

export const Favorite = Record({
  id: null,
  itemType: null,
  itemId: null,
  source: null,
  createdAt: null
})

export const deserializeFavorite = (favorite) => {
  const {
    id,
    favorited_object_type: itemType,
    favorited_object_id: itemId,
    source,
    created_at: createdAt
  } = favorite
  return Favorite({
    id,
    createdAt,
    itemType: itemType && itemType.toLowerCase(),
    itemId,
    source
  })
}

export const deserializeSingleFavorite = (favorite) => {
  return Favorite({
    id: favorite.id,
    itemType: favorite.favorited_object_type.toLowerCase(),
    itemId: favorite.favorited_object_id,
    source: favorite.source,
    createdAt: favorite.created_at
  })
}
